const { use } = require('@fegobull/webapi');
const $t = require('./i18n').default;

/**
 * 根据错误码获取对应的多语言提示文案
 * @param {number} code - 错误码
 * @returns {string} - 对应的多语言提示文案
 */
const getErrorMessage = (code) => {
    const key = `error_${code}`;
    const message = $t(key);
    // 如果找不到对应的错误码文案，返回默认提示
    if (message === key) {
        return $t('error_default');
    }
    return message;
};

/**
 * 处理 API 响应错误
 * 当 code 不为 0 时，自动弹出 Toast 提示
 * @param {object} response - API 响应对象 { code, data, message }
 * @returns {boolean} - 返回 true 表示有错误，false 表示无错误
 */
const handleApiError = (response) => {
    if (!response || response.code === 0) {
        return false;
    }

    const Toast = use.useToast();
    const errorMessage = getErrorMessage(response.code);
    Toast.info(errorMessage);

    return true;
};

module.exports = {
    getErrorMessage,
    handleApiError
};
